import React, { useMemo } from "react";
import { Badge, Stack } from "react-bootstrap";

import * as AiIcons from "react-icons/ai";
import { getStatus } from "../../utils/AuxFunctions";
import moment from "moment";
import PropTypes from "prop-types";
import Icon from "../../components/Icon";
import DropDownCustom from "../../components/generic/_DropDown";
import { useAuth } from "../../Context/AuthContext";
import { Table } from "../../components/ui/Table";
import { StatusChip } from "../../components/ui/Chip";

const CampaignMessages = ({
  setShow,
  setShowDetail,
  dataBaseInfo,
  setIdRecordToDetail,
  setIdRecordMessageToDelete,
  setShowConfirmCancel,
  setStatus,
  setNameCampaign,
  isDatabaseDeleted,
  setShowPreview,
  setMessagePreview,
}) => {
  const auth = useAuth();
  const channel = auth.getUserChannel();

  const getChannels = useMemo(() => {
    const CHANNEL_ARRAY = [
      {
        label: "Mensajes de texto (SMS)",
        icon: "sms",
        key: "SMS",
      },
      {
        label: "RCS",
        icon: "rcs",
        key: "RCS",
      },
    ];

    if (channel.includes("ALL")) return CHANNEL_ARRAY;

    return CHANNEL_ARRAY.filter((item) => channel.includes(item.key));
  }, [channel]);

  const columns = [
    {
      accessor: "message",
      Header: "Mensaje",
      Cell: (rowData) => {
        let isEmail = rowData.row.original.isEmail;
        let isWhatsapp = rowData.row.original.isWhatsapp;
        let message = rowData.row.original.message;
        return (
          <>
            {isEmail || isWhatsapp ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: 1, paddingRight: "10px" }}>
                  {message.substring(0, 99) + "..."}
                </div>
                <div
                  style={{
                    cursor: "pointer",
                    flexShrink: 0,
                    display: "flex",
                    paddingLeft: "10px",
                    alignItems: "center",
                  }}
                >
                  <AiIcons.AiOutlinePlayCircle
                    className="IconTable"
                    title="Previsualizar"
                    onClick={() => {
                      setShowPreview(true);
                      setMessagePreview(message);
                    }}
                  />
                </div>
              </div>
            ) : (
              message
            )}
          </>
        );
      },
    },
    {
      accessor: "sendDate",
      Header: "Fecha Programada",
      Cell: (rowData) => {
        let sendDate = rowData.row.original.sendDate;
        return moment(sendDate).format("DD/MM/YYYY HH:mm");
      },
    },
    {
      accessor: "execution",
      Header: "Fecha de Ejecucion",
      Cell: (rowData) => {
        let execution = rowData.row.original.execution;
        let idStatus = rowData.row.original.idStatus;
        return idStatus == 1 || idStatus == 4
          ? "-"
          : moment(execution).format("DD/MM/YYYY HH:mm");
      },
    },
    {
      accessor: "type",
      Header: "Tipo",
      Cell: (rowData) => {
        const { isEmail, isSms, isWhatsapp, isRcs } = rowData.row.original;

        const renderIcons = () => {
          switch (true) {
            case isEmail:
              return (
                <StatusChip label="Email" variant="neutral" isStatus={false} />
              );
            case isSms:
              return (
                <StatusChip label="SMS" variant="bound" isStatus={false} />
              );
            case isWhatsapp:
              return (
                <StatusChip
                  label="WhatsApp"
                  variant="success"
                  isStatus={false}
                />
              );
            case isRcs:
              return <StatusChip label="RCS" variant="info" isStatus={false} />;
            default:
              return <Icon icon="question_mark" />;
          }
        };

        return <div className="flex items-center">{renderIcons()}</div>;
      },
    },
    {
      accessor: "idStatus",
      Header: "Estatus",
      Cell: (rowData) => {
        let idStatus = rowData.row.original.idStatus;
        let status = getStatus(idStatus);

        const mapStatus = {
          1: "primary",
          2: "info",
          3: "success",
          4: "danger",
        };

        return <Badge bg={mapStatus[idStatus]}>{status}</Badge>;
      },
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let iddetail = rowData.row.original.idCampaignMessage;
        let idStatus = rowData.row.original.idStatus;
        let nameCampaign = rowData.row.original.message;
        return (
          <>
            {idStatus == 1 ? (
              <>
                <AiIcons.AiOutlineStop
                  className="IconTable"
                  title="Desactivar"
                  onClick={() => {
                    setIdRecordMessageToDelete(iddetail);
                    setShowConfirmCancel(true);
                  }}
                />
                {" | "}
              </>
            ) : (
              ""
            )}
            <>
              <AiIcons.AiOutlineSearch
                className="IconTable"
                title="Detalles"
                onClick={() => {
                  const value = rowData.row.original;
                  let type = null;

                  if (value.isSms) {
                    type = "sms";
                  } else if (value.isRcs) {
                    type = "rcs";
                  } else if (value.isEmail) {
                    type = "email";
                  } else if (value.isWhatsapp) {
                    type = "whatsapp";
                  }

                  setShowDetail({
                    visible: true,
                    data: value,
                    type,
                  });

                  setIdRecordToDetail(iddetail);
                  setStatus(idStatus);
                  setNameCampaign(nameCampaign);
                }}
              />{" "}
            </>
          </>
        );
      },
    },
  ];
  return (
    <>
      <Stack direction="horizontal" className="wrappTitle" gap={2}>
        <div>
          <h4>Lista de Mensajes Configurados</h4>
        </div>
        <div className="ms-auto">
          {/* {!isDatabaseDeleted && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => {
                setIdRecord(0);
                setShow(true);
              }}
            >
              <AiIcons.AiOutlinePlus /> Hola
            </Button>
          )} */}

          {!isDatabaseDeleted && (
            <DropDownCustom
              title="Agregar"
              bodyTitle="Seleccione el tipo de Mensaje"
              options={getChannels}
              onChange={setShow}
            />
          )}
        </div>
      </Stack>
      <Table
        columns={columns}
        data={dataBaseInfo}
        loading={!dataBaseInfo.length}
        config={{
          search: true,
          pageSize: 10,
          perPage: 20,
          sortable: true,
          pagination: true,
          rowInfo: true,
          navButtons: false,
          infoSize: "sm",
          iconInfoSize: 20,
        }}
      />
    </>
  );
};
CampaignMessages.propTypes = {
  setShow: PropTypes.func.isRequired,
  setShowDetail: PropTypes.func.isRequired,
  dataBaseInfo: PropTypes.array.isRequired,
  setIdRecord: PropTypes.func.isRequired,
  setIdRecordToDetail: PropTypes.func.isRequired,
  setIdRecordMessageToDelete: PropTypes.func.isRequired,
  setShowConfirmCancel: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
  setNameCampaign: PropTypes.func.isRequired,
  isDatabaseDeleted: PropTypes.bool.isRequired,
  setShowPreview: PropTypes.func.isRequired,
  setMessagePreview: PropTypes.func.isRequired,
};
export default CampaignMessages;
